var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { useUpdate } from 'src/shared/hooks/useLifecycle';
import { useDebounce } from 'src/shared/hooks/useDebounce';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './textInput.module.scss';
import { IDENTIFIER_TEXT_INPUT, IDENTIFIER_TEXT_INPUT_ERROR } from 'src/ui/components/Input/TextInput/constants';
export var TextInput = forwardRef(function (props, ref) {
    var _a, _b, _c, _d;
    var label = props.label, isLabelOnTop = props.isLabelOnTop, placeholder = props.placeholder, type = props.type, value = props.value, className = props.className, rightIcon = props.rightIcon, iconColor = props.iconColor, disabled = props.disabled, multiple = props.multiple, _e = props.maxRows, maxRows = _e === void 0 ? 1 : _e, withInfo = props.withInfo, isError = props.isError, infoMessage = props.infoMessage, onIconClick = props.onIconClick, onChange = props.onChange, onFocusChange = props.onFocusChange, timeDebounce = props.timeDebounce;
    var inputRef = useRef(null);
    var _f = useState(false), inputFocus = _f[0], setInputFocus = _f[1];
    var _g = useState(value), tempValue = _g[0], setTempValue = _g[1];
    useImperativeHandle(ref, function () { return inputRef.current; });
    useUpdate(function () {
        setTempValue(value);
    }, [value]);
    useUpdate(function () {
        if (onFocusChange) {
            onFocusChange(inputFocus);
        }
    }, [inputFocus]);
    var handleTextInputClick = function (e) {
        if (disabled) {
            return;
        }
        inputRef.current.focus();
    };
    var handleFocus = function () {
        setInputFocus(true);
    };
    var textChangeDebounce = useDebounce(onChange, timeDebounce);
    var handleChange = function (e) {
        var value = e.target.value;
        setTempValue(value);
        if (timeDebounce) {
            textChangeDebounce(value);
        }
        else {
            onChange(value);
        }
    };
    var textInputWrapperClass = classNames(styles.textInputWrapper, (_a = {}, _a[styles.textInputNoLabel] = !!!label, _a), className);
    var labelClass = classNames(styles.label, (_b = {},
        _b[styles.labelOnTop] = isLabelOnTop || inputFocus || !!tempValue,
        _b));
    var inputClass = classNames(styles.textInput, (_c = {},
        _c[styles.inputValueFocused] = inputFocus,
        _c[styles.inputValueDisabled] = !!disabled,
        _c[styles.inputValueError] = !!withInfo && !!isError,
        _c));
    var infoClassName = classNames(styles.infoMessage, (_d = {}, _d[styles.infoMessageError] = isError, _d));
    return (_jsxs("div", __assign({ className: textInputWrapperClass, onClick: handleTextInputClick }, { children: [_jsxs("div", __assign({ className: inputClass }, { children: [multiple ? (_jsx("textarea", { "data-test": IDENTIFIER_TEXT_INPUT, ref: inputRef, placeholder: placeholder, value: tempValue || '', disabled: !!disabled, onChange: handleChange, rows: maxRows, onFocus: handleFocus, onBlur: function () { return setInputFocus(false); } })) : (_jsx("input", { "data-test": IDENTIFIER_TEXT_INPUT, ref: inputRef, placeholder: placeholder, type: type, value: tempValue || '', disabled: !!disabled, onChange: handleChange, onFocus: handleFocus, onBlur: function () { return setInputFocus(false); } })), _jsx("p", __assign({ className: labelClass }, { children: label })), (rightIcon || !!disabled) && (_jsx(Icons, { className: styles.searchIcon, icon: rightIcon || E_ICONS.LOCK, color: !!disabled ? COLORS.GRAY['500'] : iconColor || null, onClick: onIconClick }))] })), withInfo && (_jsxs("div", __assign({ "data-test": IDENTIFIER_TEXT_INPUT_ERROR, className: infoClassName, style: { opacity: infoMessage ? 1 : 0 } }, { children: [infoMessage && _jsx(Icons, { icon: E_ICONS.INFO }), infoMessage && _jsx("p", { children: infoMessage })] })))] })));
});
